import { Link } from "react-router-dom";
import { ChevronRight, CalendarDays, Clock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHead, CtaBand } from "@/components/Blocks";
import { INSIGHTS, IMAGES } from "@/data/contentEngine";

const InsightsIndex = () => (
  <>
    <Seo
      title="Security Insights & Advice | Northern Ireland Security Blog | Xtreme Protection"
      description="Expert security advice for Northern Ireland businesses: choosing security companies, SIA licensing, construction site security, retail loss prevention, key holding & event safety."
      path="/insights"
    />
    <PageHero
      eyebrow="Security Insights"
      title="Northern Ireland security advice"
      sub="Practical guidance from the field — licensing, loss prevention, site security and event safety, written for NI businesses."
      image={IMAGES.cctvWall}
      testId="insights-hero"
    />
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-12">
      <SectionHead eyebrow="Latest Articles" title="From the control room" testId="insights-heading" />
      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {INSIGHTS.map((a, i) => (
          <Reveal key={a.slug} delay={(i % 3) * 0.08}>
            <Link
              to={`/insights/${a.slug}`}
              data-testid={`insight-card-${a.slug}`}
              className="tactical-card group flex h-full flex-col rounded-md p-6"
            >
              <span className="w-fit rounded-sm border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-amber-400">
                {a.category}
              </span>
              <h2 className="mt-4 font-display text-xl font-bold uppercase leading-snug tracking-wide text-slate-100">
                {a.title}
              </h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{a.excerpt}</p>
              <div className="mt-5 flex items-center justify-between border-t border-slate-800 pt-4">
                <span className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-wider text-slate-500">
                  <span className="flex items-center gap-1">
                    <CalendarDays className="h-3 w-3" />
                    {new Date(a.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="h-3 w-3" /> {a.readTime}
                  </span>
                </span>
                <ChevronRight className="h-4 w-4 text-slate-600 transition-all duration-300 group-hover:translate-x-1 group-hover:text-amber-500" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
    <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-12">
      <CtaBand
        title="Need advice on your own site?"
        sub="A free risk assessment answers most security questions in one visit. Call the control room or email the team."
      />
    </section>
  </>
);

export default InsightsIndex;
